export const svgStr = `
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="58" viewBox="0 0 48 58">
  <ellipse cx="24" cy="54" rx="18" ry="3" fill="rgba(0,0,0,0.15)"/>
  <rect x="20" y="6" width="8" height="8" rx="1" fill="#dc2626"/>
  <polygon points="18,6 24,1 30,6" fill="#475569"/>
  <circle cx="24" cy="10" r="1.5" fill="#fbbf24"/>
  <rect x="8" y="24" width="32" height="28" rx="2" fill="#dc2626"/>
  <polygon points="5,24 24,12 43,24" fill="#475569"/>
  <path d="M20 52V38h8v14z" fill="#78350f"/>
  <circle cx="22" cy="45" r="0.75" fill="#fbbf24"/>
  <rect x="12" y="29" width="6" height="7" rx="1" fill="#e0f2fe"/>
  <line x1="15" y1="29" x2="15" y2="36" stroke="#bae6fd" stroke-width="0.75"/>
  <line x1="12" y1="32.5" x2="18" y2="32.5" stroke="#bae6fd" stroke-width="0.75"/>
  <rect x="30" y="29" width="6" height="7" rx="1" fill="#e0f2fe"/>
</svg>`;

export const svgMultiStr = `
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="58" viewBox="0 0 48 58">
  <ellipse cx="24" cy="54" rx="18" ry="3" fill="rgba(0,0,0,0.15)"/>
  <rect x="20" y="6" width="8" height="8" rx="1" fill="#d97706"/>
  <polygon points="18,6 24,1 30,6" fill="#475569"/>
  <circle cx="24" cy="10" r="1.5" fill="#fbbf24"/>
  <rect x="8" y="24" width="32" height="28" rx="2" fill="#d97706"/>
  <polygon points="5,24 24,12 43,24" fill="#475569"/>
  <path d="M20 52V38h8v14z" fill="#78350f"/>
  <circle cx="22" cy="45" r="0.75" fill="#fbbf24"/>
  <rect x="12" y="29" width="6" height="7" rx="1" fill="#e0f2fe"/>
  <line x1="15" y1="29" x2="15" y2="36" stroke="#bae6fd" stroke-width="0.75"/>
  <line x1="12" y1="32.5" x2="18" y2="32.5" stroke="#bae6fd" stroke-width="0.75"/>
  <rect x="30" y="29" width="6" height="7" rx="1" fill="#e0f2fe"/>
  <circle cx="38" cy="12" r="8" fill="#dc2626" stroke="#fff" stroke-width="2"/>
  <text x="38" y="16" text-anchor="middle" font-size="11" fill="#fff" font-family="sans-serif" font-weight="bold">+</text>
</svg>`;

export const loadSVGImage = (map, id, svgString) => {
  return new Promise((resolve) => {
    if (map.hasImage(id)) {
      resolve();
      return;
    }

    const blob = new Blob([svgString], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const img = new Image();
    
    img.onload = () => {
      const width = 48;
      const height = 58;

      const animatedImage = {
        width: width,
        height: height,
        data: new Uint8Array(width * height * 4),
        
        onAdd: function () {
          this.canvas = document.createElement("canvas");
          this.canvas.width = this.width;
          this.canvas.height = this.height;
          this.context = this.canvas.getContext("2d");
        },

        render: function () {
          const ctx = this.context;
          if (!ctx) return false;
          
          // 1. Draw base schoolhouse
          ctx.clearRect(0, 0, this.width, this.height);
          ctx.drawImage(img, 0, 0, this.width, this.height);

          // 2. Generate custom random traits per layout call
          const center = map.getCenter();
          const seedX = Math.abs(Math.sin(center.lng * 1000 + (id === 'school-pin' ? 1 : 2)));
          const seedY = Math.abs(Math.cos(center.lat * 1000));

          // Unique intervals and timings
          const timeOffset = seedX * 8.0; 
          const loopDuration = 5.5 + (seedY * 3.5); // Ranges from 5.5s to 9s
          const time = performance.now() / 1000;
          const cycle = (time + timeOffset) % loopDuration;

          // Split location profiles into 3 distinct zones based on math seeds
          const locationDice = (seedX * 10) % 3; 
          const isDoorKid = locationDice >= 2;        // 33% chance for door
          const isLeftWindow = locationDice < 1;       // 33% chance for left window
          // Remaining 34% chance defaults to right window

          let isWaving = false;

          // ── SCENARIO A: DOOR PEEKING KID ──
          if (isDoorKid) {
            let kidOffsetX = -5; // Hidden left behind door frame

            if (cycle > 1.2 && cycle < 4.2) {
              if (cycle < 1.6) {
                kidOffsetX = -5 + ((cycle - 1.2) / 0.4) * 5; // Slide out sideways
              } else if (cycle > 3.8) {
                kidOffsetX = ((cycle - 3.8) / 0.4) * -5;    // Slide in
              } else {
                kidOffsetX = 0;
                isWaving = true;
              }
            }

            const waveAngle = isWaving ? Math.sin(time * 17) * 0.22 : 0;

            ctx.save();
            ctx.beginPath(); ctx.rect(20, 38, 8, 14); ctx.clip(); // Clip to open door layout
            ctx.translate(22 + kidOffsetX, 44);

            // Render Kid Profile
            ctx.fillStyle = "#0284c7"; ctx.fillRect(-2, 2, 4, 6);
            ctx.fillStyle = "#fed7aa"; ctx.beginPath(); ctx.arc(0, 0, 1.8, 0, Math.PI * 2); ctx.fill();
            ctx.fillStyle = "#1e293b";
            ctx.beginPath(); ctx.arc(-0.6, -0.2, 0.3, 0, Math.PI * 2); ctx.fill();
            ctx.beginPath(); ctx.arc(0.4, -0.2, 0.3, 0, Math.PI * 2); ctx.fill();
            ctx.fillStyle = "#b91c1c";
            ctx.beginPath(); ctx.arc(0, -0.3, 1.9, Math.PI, 0); ctx.fill(); ctx.fillRect(0, -2.3, 2.5, 0.6);

            // Arm Mechanics
            ctx.save();
            ctx.translate(-1, 2); ctx.rotate(waveAngle); ctx.translate(1, -2);
            ctx.strokeStyle = "#0284c7"; ctx.lineWidth = 0.9; ctx.beginPath(); ctx.moveTo(-1, 2); ctx.lineTo(-3, 0); ctx.stroke();
            ctx.strokeStyle = "#fed7aa"; ctx.lineWidth = 0.7; ctx.beginPath(); ctx.moveTo(-3, 0); ctx.lineTo(-4, -1.5); ctx.stroke();
            ctx.fillStyle = "#fed7aa"; ctx.beginPath(); ctx.arc(-4.2, -2, 0.6, 0, Math.PI * 2); ctx.fill();
            ctx.restore();

            ctx.restore();

            // Repaint open door panel on top of the peek stream loop
            ctx.fillStyle = "#5c2505";
            ctx.fillRect(24, 38, 4, 14);
            ctx.fillStyle = "#fbbf24"; ctx.beginPath(); ctx.arc(25, 45, 0.6, 0, Math.PI * 2); ctx.fill();
          } 
          
          // ── SCENARIO B: WINDOW POPPING KID (Left or Right) ──
          else {
            const windowX = isLeftWindow ? 12 : 30;
            const windowY = 29;
            let kidOffsetY = 8;

            if (cycle > 1.0 && cycle < 4.0) {
              if (cycle < 1.3) {
                kidOffsetY = 8 - ((cycle - 1.0) / 0.3) * 8; // Pop up
              } else if (cycle > 3.7) {
                kidOffsetY = ((cycle - 3.7) / 0.3) * 8;     // Duck down
              } else {
                kidOffsetY = 0;
                isWaving = true;
              }
            }

            const waveAngle = isWaving ? Math.sin(time * 15) * 0.25 : 0;

            ctx.save();
            ctx.beginPath(); ctx.rect(windowX, windowY, 6, 7); ctx.clip();
            ctx.translate(isLeftWindow ? (windowX - 30) : 0, kidOffsetY);

            // Render Kid Body
            ctx.fillStyle = "#0284c7"; ctx.fillRect(31, 34, 4, 4);
            ctx.fillStyle = "#fed7aa"; ctx.beginPath(); ctx.arc(33, 32.5, 1.75, 0, Math.PI * 2); ctx.fill();
            ctx.fillStyle = "#1e293b";
            ctx.beginPath(); ctx.arc(32.3, 32.3, 0.3, 0, Math.PI * 2); ctx.fill();
            ctx.beginPath(); ctx.arc(33.2, 32.3, 0.3, 0, Math.PI * 2); ctx.fill();
            ctx.fillStyle = "#b91c1c"; ctx.beginPath(); ctx.arc(33, 32.2, 1.8, Math.PI, 0); ctx.fill(); ctx.fillRect(33, 30.2, 2.5, 0.6); 

            // Arm mechanics
            ctx.save();
            ctx.translate(31.5, 34); ctx.rotate(waveAngle); ctx.translate(-31.5, -34);
            ctx.strokeStyle = "#0284c7"; ctx.lineWidth = 0.8; ctx.lineCap = "round"; ctx.beginPath(); ctx.moveTo(31.5, 34); ctx.lineTo(29.5, 32); ctx.stroke();
            ctx.strokeStyle = "#fed7aa"; ctx.lineWidth = 0.6; ctx.beginPath(); ctx.moveTo(29.5, 32); ctx.lineTo(28.5, 30.5); ctx.stroke();
            ctx.fillStyle = "#fed7aa"; ctx.beginPath(); ctx.arc(28.2, 29.8, 0.6, 0, Math.PI * 2); ctx.fill();
            ctx.restore();
            ctx.restore();
          }

          // 4. Overlap window pane frame lines back cleanly on top
          ctx.strokeStyle = "rgba(186, 230, 253, 0.9)";
          ctx.lineWidth = 0.75;
          ctx.beginPath(); ctx.moveTo(15, 29); ctx.lineTo(15, 36); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(12, 32.5); ctx.lineTo(18, 32.5); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(33, 29); ctx.lineTo(33, 36); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(30, 32.5); ctx.lineTo(36, 32.5); ctx.stroke();

          // Sync data context output
          const imageData = ctx.getImageData(0, 0, this.width, this.height);
          this.data = imageData.data;

          map.triggerRepaint();
          return true;
        }
      };

      map.addImage(id, animatedImage);
      resolve();
    };

    img.src = url;
  });
};